module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei6.svg";